import React from "react";
import { Link } from "react-router-dom";
import { User, LogOut } from "lucide-react";
import styles from "./UserInfo.module.css";
import { useAuth } from "@/providers/AuthProvider";

const UserInfoDisplay: React.FC = () => {
    const { user, logout } = useAuth();

    if (!user) {
        return (
            <div className={styles["user-menu"]}>
                <span className={styles["user-name"]}>Usuario no disponible</span>
            </div>
        );
    }

    const { first_name, last_name, role } = user;
    const fullName = `${first_name} ${last_name}`;
    const initials = `${first_name?.[0] ?? ""}${last_name?.[0] ?? ""}`;

    return (
        <div className={styles["user-menu"]}>
            <div className={styles["user-info"]}>
                <div className={styles["user-name"]}>{fullName}</div>
                {role && <div className={styles["user-role"]}>{role}</div>}
            </div>

            <div className={styles["user-avatar"]} aria-hidden="true">
                {initials}
            </div>

            <span className={styles["divider"]} />

            <Link
                to="/mis-datos"
                className={styles["icon-action"]}
                title="Mis datos"
                aria-label="Mis datos"
            >
                <User size={18} />
            </Link>

            <button
                onClick={logout}
                className={`${styles["icon-action"]} ${styles["logout"]}`}
                title="Cerrar sesión"
                aria-label="Cerrar sesión"
            >
                <LogOut size={18} />
            </button>
        </div>
    );
};

export default UserInfoDisplay;
